import React from 'react';
import { getOvertimeReport } from '../../services/timesheetService';
import PresetReportPage from './components/PresetReportPage';

// AKM POC §5.15 / §7 — Devam Paneli'nden panel süzgeçleriyle açılabilir; ortak süzgeç seti, TA ekip kapsamı ve sunucu
// tarafı Excel / PDF dışa aktarma ortak gövdede (PresetReportPage).
export default function OvertimePage() {
  return <PresetReportPage fetchFn={getOvertimeReport} titleKey="pdks.overtimeTitle" exportUrl="/v1/ta/reports/overtime/export" />;
}
